import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';

export const getSurveyReview = (orderId) => {
  return api.get(URLS.surveyReview, {
    params: {
      id: orderId
    },
    headers: {
      needsToken: true
    }
  });
};

// Partial autosave — the body carries only the header fields and questions that
// changed since the last save.
export const saveSurveyReview = (orderId, data) => {
  return api.post(URLS.saveSurveyReview, data, {
    params: {
      id: orderId
    },
    headers: {
      needsToken: true
    }
  });
};

export const generateSurveyReviewDocument = (orderId) => {
  return api.post(
    URLS.generateSurveyReviewDocument,
    {},
    {
      params: {
        id: orderId
      },
      headers: {
        needsToken: true
      }
    }
  );
};

// Resolves the prompt raised when a newer survey document has been uploaded
// over a review that already holds reviewer answers. `action` is
// 'rerun' (refill from the new document) or 'ignore' (keep the existing answers).
export const resolveSurveyReviewNewDocument = (orderId, action) => {
  return api.put(
    URLS.surveyReviewNewDocument,
    { action },
    {
      params: {
        id: orderId
      },
      headers: {
        needsToken: true
      }
    }
  );
};

// Re-runs the survey analysis after it ended in `processing_failed`.
export const retrySurveyReview = (orderId) => {
  return api.post(URLS.surveyReviewRetry, null, {
    params: {
      id: orderId
    },
    headers: {
      needsToken: true
    }
  });
};
